import React, { useState } from "react";
import { Play } from "lucide-react";
import { Section, FadeUp, Eyebrow, CtaButton } from "./primitives";
import { media } from "@/data/content";

export const Hero = () => {
  const [playing, setPlaying] = useState(false);
  return (
    <Section className="bg-white pt-14 md:pt-20">
      <div className="max-w-[820px] mx-auto text-center">
        <FadeUp>
          <Eyebrow>Lead Guitar Freedom</Eyebrow>
        </FadeUp>
        <FadeUp delay={0.05}>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-zinc-900 leading-[1.05]">
            Play Fast, Fluid Rock Solos In 60 Days Even If You've Been Stuck For Years
          </h1>
        </FadeUp>
        <FadeUp delay={0.1}>
          <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed max-w-[720px] mx-auto">
            A hands-on 60-day program for intermediate rock guitarists who want to build the technique and
            improvisation skills to finally play solos like they always wanted.
          </p>
        </FadeUp>

        <FadeUp delay={0.15}>
          <div className="mt-10 max-w-[900px] mx-auto rounded-xl overflow-hidden border border-zinc-200 shadow-lg bg-black">
            <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
              {playing ? (
                <iframe
                  data-testid="vsl-video"
                  className="absolute inset-0 h-full w-full"
                  src={`https://player.vimeo.com/video/${media.vimeoId}?autoplay=1`}
                  title="Video Sales Letter for Lead Guitar Freedom"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  allowFullScreen
                />
              ) : (
                <button
                  type="button"
                  data-testid="vsl-thumbnail"
                  onClick={() => setPlaying(true)}
                  aria-label="Play the video sales letter"
                  className="absolute inset-0 h-full w-full group cursor-pointer focus:outline-none"
                >
                  <img
                    src={media.vslThumbnail}
                    alt="Doug presenting the Lead Guitar Freedom video sales letter"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                  <span className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200" />
                  <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex h-20 w-20 items-center justify-center rounded-full bg-[#D90429] text-white shadow-xl group-hover:scale-110 transition-transform duration-200">
                    <Play className="h-8 w-8 ml-1" fill="currentColor" />
                  </span>
                </button>
              )}
            </div>
          </div>
        </FadeUp>

        <FadeUp delay={0.2}>
          <div className="mt-10">
            <CtaButton testid="cta-hero-apply" />
          </div>
        </FadeUp>
      </div>
    </Section>
  );
};
